import { Component, Input } from '@angular/core';
import { CnEditmodeService } from '../challenges_service/cn-editmode.service';

@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss']
})
export class MenuBarComponent {

  pin_challenge: boolean = false;
  listGridView: string = 'listView';
  gridViewClass: string = '';
  @Input() editContentTitle: string = '';

  constructor(public editmodeService: CnEditmodeService) {}
}
